// decode data
export function decodeData(data) {
  try {
    if (data) {
      try {
        return decodeURIComponent(unescape(data));
      } catch (e) {
        return unescape(decodeURIComponent(data));
      }
    }
  } catch (e) {
    return '';
  }
}

export function convertUTCtoEST(utcTimeString) {
  utcTimeString = utcTimeString.replace("Z", "")
  // Parse the UTC time string
  let [datePart, timePart] = utcTimeString.split('T');
  let [year, month, day] = datePart.split('-').map(Number);
  let [hour, minute, second] = timePart.split(':').map(Number);

  // Subtract 4 hours for EST (Eastern Standard Time)
  hour -= 4;

  // Check for negative hours and adjust the date accordingly
  if (hour < 0) {
    // Adjust the date back by 1 day
    const utcDate = new Date(Date.UTC(year, month - 1, day, hour + 24, minute, second));
    return utcDate.toISOString().replace('T', ' ').slice(0, -5);
  } else {
    const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    return utcDate.toISOString().replace('T', ' ').slice(0, -5);
  }
}


export const paginationArray = {
  paginatiorOptions: [
    50, 100, 250, 500, 1000
  ]
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/services/common-service.ts